import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, concatMap } from 'rxjs/operators';
import { of, from } from 'rxjs';
import { TransactionActions } from './transaction.actions';
import { TransactionsService } from '../_services/transactions.service';


@Injectable()
export class TransactionEffects {

  loadTransactions$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(TransactionActions.loadTransactions),
      concatMap((action) =>
        from(this.service.getTransactions(action.query)).pipe(
          map(transactions => TransactionActions.loadTransactionsSuccess({ transactions })),
          catchError(error => of(TransactionActions.apiFailure({ error })))
        )
      )
    );
  });

  getTransactionById$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(TransactionActions.getTransactionById),
      concatMap((action) =>
        from(this.service.getTransactionById(action.id)).pipe(
          map(transaction => TransactionActions.getOneSuccess({ transaction })),
          catchError(error => of(TransactionActions.apiFailure({ error })))
        )
      )
    );
  });

  getTransactionByServiceId$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(TransactionActions.getTransactionByServiceId),
      concatMap((action) =>
        from(this.service.getTransactionByServiceId(action.service_id)).pipe(
          map(transaction => TransactionActions.getOneSuccess({ transaction })),
          catchError(error => of(TransactionActions.apiFailure({ error })))
        )
      )
    );
  });

  upsertTransaction$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(TransactionActions.upsertTransaction),
      concatMap((action) =>
        from(this.service.upsertTransaction(action.transaction)).pipe(
          map(_null => TransactionActions.purgeTransaction({ id: action.transaction.id as string })),
          catchError(error => of(TransactionActions.apiFailure({ error })))
        )
      )
    );
  });


  constructor(private actions$: Actions, private service: TransactionsService) {}
}
